/**
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
 * > In summary, we recommend looking for the string “Mobi” anywhere in the User Agent to detect a mobile device.
 */
export const isMobile = (userAgent) => !!userAgent && !!userAgent.match(/Mobi/);
export const isChromium = (userAgent) => !!userAgent && userAgent.toLowerCase().indexOf('chrome') > -1;
export const isIOS = (userAgent) => !!userAgent && !!userAgent.match(/(iPhone|iPad|iPod)/);
